import { saveAs } from "file-saver"

export default function (response, params) {
  let { fileName } = params

  let blob = new Blob([response], { type: "octet/stream" })
  saveAs(blob, fileName)
}
